import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { RefId } from '@core/interface/ref-id.interface';
import { Observable } from 'rxjs';
import { CreateManagementReportAccountingRequestDto } from '../dtos/create-management-report-accounting.request.dto';
import { ListManagementReportAccountingRequestDto } from '../dtos/list-management-report-accounting.request.dto';
import { ManagementReportAccountingResponseDto } from '../dtos/management-report-accounting.response.dto';
import { UpdateManagementReportAccountingRequestDto } from '../dtos/update-management-report-accounting.request.dto';
import { ValidateErpManagementReportAccountingResponseDto } from '../dtos/validate-erp-management-report-accounting.response.dto';

export abstract class ManagementReportAccountingRepository {
  abstract list(
    request: ListManagementReportAccountingRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementReportAccountingResponseDto>>
  >;

  abstract show(
    request: RefId,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>>;

  abstract create(
    request: CreateManagementReportAccountingRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>>;

  abstract update(
    request: UpdateManagementReportAccountingRequestDto,
  ): Observable<ApiResponse<ManagementReportAccountingResponseDto>>;

  abstract delete(request: RefId): Observable<ApiResponse<void>>;

  abstract validateErp(
    request: RefId,
  ): Observable<ApiResponse<ValidateErpManagementReportAccountingResponseDto>>;
}
